export default __webpack_public_path__ + "static/media/150.16d3b171.svg";